export default "/images/addToHomeScreen.png?c218fcc12acb3739af54942dc55bfa29";